import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { WhoAmIVM } from '../../../models';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientDashboardVM } from '../../../models/ClientDashboardVM';
import { AccountService } from '../../../services/account.service';
import { SessionBookingVM } from '../../../models/SessionBookingVM';
import { SessionCancelStatus } from '../../../models/SessionCancelStatus';
import { MessagePartyVM } from '../../../models/MessagePartyVM';
import { UserType } from '../../../models/UserType';

@Component({
  selector: 'sessions',
  templateUrl: './sessions.component.html'
})
export class SessionsComponent extends BaseComponent implements OnInit {

  model: ClientDashboardVM = new ClientDashboardVM();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private accService: AccountService
  ) {
    super(route);
  }

  ngOnInit(): void {
    this.emitDisplayLoadingDialog(true);
    this.accService.getDashboard(true)
      .subscribe(returnValue => {
        this.model = returnValue;
      },
        error => { this.showDialog("Error loading information, please try again", true); },
        () => { this.emitDisplayLoadingDialog(false); }
      );
  }

  getCancellationStatus(item: SessionBookingVM): string {
    switch (item.cancelStatus) {
      case SessionCancelStatus.pending:
        return '(Cancellation Pending)';
      case SessionCancelStatus.cancelled:
        return '(Cancelled)';
      default:
        return '';
    }
  }

  onSessionDataChanged() {
    this.emitDisplayLoadingDialog(true);
    this.model = new ClientDashboardVM();

    this.accService.getDashboard(true)
      .subscribe(returnValue => {
        this.model = returnValue;
      },
        error => { this.showDialog("Error loading information, please try again", true); },
        () => { this.emitDisplayLoadingDialog(false); }
      );
  }

  reply(item: SessionBookingVM) {
    var otherParty = new MessagePartyVM();
    otherParty.name = item.counsellorName;
    otherParty.userId = item.counsellorUserId;
    otherParty.userType = UserType.counsellor;
    otherParty.profileImage = item.professionalProfileImage;

    this.accService.messageOtherParty = otherParty;

    this.router.navigateByUrl('/messagewrite');
  }

}
